import React from "react";
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";

class Reportessolvencias extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            desde: "",
            hasta: "",
            usuario: "",
            usuarios: []
        };
    }

    componentDidMount() {
        fetch(api + "usuarios", {
            headers: authHeaders()
        })
            .then(respuesta => respuesta.json())
            .then(datos => {
                this.setState({
                    usuarios: Array.isArray(datos) ? datos : []
                });
            });
    }

    cambioUsuario = (e) => {
        this.setState({ usuario: e.target.value });
    }

    cambioDesde = (e) => {
        this.setState({ desde: e.target.value });
    }

    cambioHasta = (e) => {
        this.setState({ hasta: e.target.value });
    }

    abrirReporte = async (ruta) => {
        const { desde, hasta, usuario } = this.state;

        let url = api + ruta + "?";

        if (desde) url += `desde=${desde}&`;
        if (hasta) url += `hasta=${hasta}&`;
        if (usuario) url += `usuario=${usuario}&`;

        try {
            const respuesta = await fetch(url, {
                method: "GET",
                headers: authHeaders()
            });

            if (!respuesta.ok) {
                const error = await respuesta.text();
               
                alert("No se pudo generar el reporte. Revisa la consola.");
                return;
            }

            const blob = await respuesta.blob();
            const fileURL = window.URL.createObjectURL(blob);

            window.open(fileURL, "_blank");

        } catch (error) {
           
            alert("Error al generar el reporte");
        }
    }

    render() {
        return (
            <div className="container mt-4">
                <div className="card shadow">

                    <div className="card-header bg-danger text-white">
                        <h4>
                            <i className="bi bi-file-earmark-pdf me-2"></i>
                            REPORTES DE SOLVENCIAS
                        </h4>
                    </div>

                    <div className="card-body">

                        <div className="row mb-4">
                            <div className="col-md-6">
                                <label>Fecha inicial</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={this.state.desde}
                                    onChange={this.cambioDesde}
                                />
                            </div>

                            <div className="col-md-6">
                                <label>Fecha final</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={this.state.hasta}
                                    onChange={this.cambioHasta}
                                />
                            </div>
                        </div>

                        <div className="row mb-4">
                            <div className="col-md-12">
                                <label>Usuario que generó la solvencia</label>

                                <select
                                    className="form-control"
                                    value={this.state.usuario}
                                    onChange={this.cambioUsuario}
                                >
                                    <option value="">Todos los usuarios</option>

                                    {this.state.usuarios.map((usuario) => (
                                        <option key={usuario.idusuario} value={usuario.idusuario}>
                                            {usuario.usuario}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 mb-3">
                                <button
                                    className="btn btn-dark w-100 p-4"
                                    onClick={() => this.abrirReporte("reportes/solvencias/general")}
                                >
                                    Reporte general
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default Reportessolvencias;